import { getInstance } from "public/Utilities/subscription";
import { postInstance, getProductById, setWidget } from 'backend/stores.web.js';
import wixWindowFrontend from 'wix-window-frontend';
import wixWidget from 'wix-widget';
import {
    getRecentProducts
} from "public/Store/store-helper";

import store from 'store';

// Handling fetch main data
export async function fetchMainData(code = 'panel') {

    try {
        //Get the props and set them to store 
        const props = code === 'panel' ? await wixWidget.getProps() : $widget.props;
        store.set('props', props);

        //Get the viewMode and set them to store 
        const { viewMode } = wixWindowFrontend;
        store.set('viewMode', viewMode);

        //Get the formFactor and set them to store 
        const { formFactor } = wixWindowFrontend;
        store.set('formFactor', formFactor);

        //Get the instance and set them to store 
        const instance = await getInstance();
        store.set('instance', instance);

        //Get the currentProduct from backend and set them to store 
        let currentProduct = await getProductById(props.productId);
        store.set('currentProduct', currentProduct);

        //Get the recentProducts from backend and set them to store 
        let recentProducts = await getRecentProducts();
        store.set('recentProducts', recentProducts);

        //Call update Instance 
        await postInstance(instance.instanceId);
        await setWidget(instance.instanceId, viewMode);

    } catch (error) {
        // Handle and log any errors that may occur during the fetch process.
        console.error('⬇️ fetchMainData ~ error: ', error);

        // Return null in case of an error.
        return null;
    }
}